import { render } from "./internship-candidates.vue?vue&type=template&id=5a5f29b2"
import script from "./internship-candidates.vue?vue&type=script&lang=js"
export * from "./internship-candidates.vue?vue&type=script&lang=js"
script.render = render

export default script